import React, { useEffect, useState } from 'react';

import AddAutomationBtn from './AddAutomationBtn';
import AutomationListing from './AutomationListing';
import BlankAutomation from './BlankAutomation';
import AutomationPostForm from './AutomationPostForm';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAuromations } from '../../../redux/actions/automationSettings';
import Loader from '../../Loader';
import Pagination from '../Pagination';
import UpgradeMessageModal from '../../UpgradeMessageModal';
import {
	CREATE_AUTOMATION_SETTINGS_RESET,
	UPDATE_AUTOMATION_SETTINGS_RESET,
} from '../../../redux/constants/automation';

const Automation = ({ groups, groupFilter, messageGroups }) => {
	const [openForm, setOpenForm] = useState(false);
	const [curpage, setCurpage] = useState(1);
	const [curautomationId, setCurautomationId] = useState('');
	const [planFailed, setPlanFailed] = useState(false);

	const automationSettings = useSelector((state) => state.automationSettings);
	const {
		loading,
		automations,
		page,
		totalPage,
		successDelete,
		successCreate,
		automationCreate,
		NotAvalidPlan,
		successUpdate,
		leadsCount,
	} = automationSettings;

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getAllAuromations(curpage, groupFilter));
	}, [dispatch, curpage, groupFilter]);

	useEffect(() => {
		if (successCreate && automationCreate?._id && !automationCreate.validPlan) {
			setPlanFailed(true);
		}
		if (successDelete) {
			dispatch(getAllAuromations(curpage, groupFilter));
		}
		if (successCreate) {
			setOpenForm(false);
			dispatch({
				type: CREATE_AUTOMATION_SETTINGS_RESET,
			});
			dispatch(getAllAuromations(curpage, groupFilter));
		}

		if (successUpdate) {
			setOpenForm(false);
			setCurautomationId('');
			dispatch({
				type: UPDATE_AUTOMATION_SETTINGS_RESET,
			});
		}
	}, [
		successDelete,
		successCreate,
		successUpdate,
		dispatch,
		curpage,
		automationCreate,
		NotAvalidPlan,
		groupFilter,
	]);
// console.log("totalPage", totalPage)

	return (
		<>
			{(openForm || planFailed) && <div className='overlayMain activate'></div>}
			{planFailed && leadsCount > 0 && (
				<UpgradeMessageModal
					setPlanFailed={setPlanFailed}
					leadsCount={leadsCount}
				/>
			)}

			{loading && <Loader />}
			<div id='tab-4' className='tab-content automationTabWrapers customizeHeights'>
      {automations && automations.length > 0  && (
				<AddAutomationBtn setOpenForm={setOpenForm} />
      )}
				{automations && automations.length ? (
					<AutomationListing
						automations={automations}
						setCurautomationId={setCurautomationId}
						setOpenForm={setOpenForm}
					/>
				) : automations && automations.length < 1 ? (
					<BlankAutomation
          setOpenForm={setOpenForm}
          />
				) : (
					''
				)}
				{openForm ? (
					<AutomationPostForm
						openForm={openForm}
						messageGroups={messageGroups}
						setOpenForm={setOpenForm}
						groups={groups}
						groupFilter={groupFilter}
						currentAutomationForUpdate={
							curautomationId
								? automations.find((a) => a._id === curautomationId)
								: ''
						}
						curautomationId={curautomationId}
						setCurautomationId={setCurautomationId}
					/>
				) : (
					''
				)}
			</div>
			<Pagination
				setCurpage={setCurpage}
				totalPage={totalPage ? totalPage : ''}
				page={page ? page : ''}
			/>
		</>
	);
};

export default Automation;
